// Base_Url
// export const API_URL = process.env.REACT_APP_API_URL
export const API_URL = "https://popgop.hiteclogs.com/api";
